"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiagnosticSlider = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _Box = _interopRequireDefault(require("../Box"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Reorder = _interopRequireDefault(require("@material-ui/icons/Reorder"));

var _Optimizers = require("../../utils/Optimizers");

var _Onboarding = require("@jobmatchme/ui/es/components/styleguide/Onboarding");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ThumbComponent = function ThumbComponent(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _extends2.default)({}, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Reorder.default, {
      className: _styleModule.default.thumbIcon
    })
  }));
};
/**
 * default MaterialUi styling
 */


var sliderHeight = parseInt(_styleModule.default.rangeSliderHeight);
var StyledSlider = (0, _withStyles.default)({
  root: {
    height: sliderHeight,
    width: '100%'
  },
  thumb: {
    background: "linear-gradient(180deg, var(--dark) 0%, var(--primaryDarker) 100%)",
    boxShadow: "-1px 9px 49px -23px rgba(0,0,0,0.75)",
    border: "3px solid var(--light),",
    color: 'var(--light)',
    marginLeft: -(parseInt(_styleModule.default.diagnosticSliderThumbWidth) / 2),
    height: parseInt(_styleModule.default.diagnosticSliderThumbHeight),
    width: parseInt(_styleModule.default.diagnosticSliderThumbWidth),
    marginTop: -14
  },
  track: {
    height: sliderHeight,
    backgroundColor: 'var(--diagnosticSliderTrack)',
    borderRadius: 'var(--borderRadius)'
  },
  rail: {
    height: sliderHeight,
    color: 'var(--light)',
    borderRadius: 'var(--borderRadius)',
    backgroundColor: 'var(--diagnosticSliderTrack)',
    border: 'none',
    opacity: 1
  }
})(_Slider.default);
/**
 * Diagnostic slider component for whitelabel registration funnel
 * @param {config} funnel config object
 * @param {contextActions} functions from ProfileProver
 * @param {context} profile context from ProfileProvider
 */

var DiagnosticSliderComponent = function DiagnosticSliderComponent(_ref) {
  var _config$educationTool;

  var config = _ref.config,
      context = _ref.context;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var startAnswerTime = new Date().getTime();

  var _useState = (0, _react.useState)(config.initialValue),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      sliderValue = _useState2[0],
      setSliderValue = _useState2[1];

  var handleSlide = function handleSlide(event, newValue) {
    return setSliderValue(newValue);
  };

  var handleCommit = function handleCommit(event, newValue) {
    var payload = {
      name: config.identifier,
      value: newValue ? String(newValue) : newValue,
      responseTime: new Date().getTime() - startAnswerTime,
      position: config.position
    };
    setValue(config.valueName, payload);
  }; // Ensure consistency between local state and commited state


  (0, _react.useEffect)(function () {
    setSliderValue((context[config.valueName].value.filter(function (el) {
      return el.name === config.identifier;
    })[0] || {}).value || config.initialValue);
  }, [config.identifier, config.initialValue, config.valueName, context]);
  /**
   * this function renders the negative, positive slider bars
   */

  var Bars = function Bars() {
    var bars = [];
    var positiveBarsCount = 1;
    var negativeBarsCount = -50;

    for (var i = 1; i < 11; i++) {
      var bar = ''; // negative bars

      if (i < 6) {
        bar = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "".concat(_styleModule.default.bar, " ").concat(_styleModule.default['_' + i], " "),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "".concat(_styleModule.default[sliderValue <= negativeBarsCount + 5 ? 'active' : ''])
          }, "ng_".concat(i))
        }, "bar-".concat(i));
        negativeBarsCount = negativeBarsCount + 10;
      } else {
        // positive bars
        bar = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "".concat(_styleModule.default.bar, " ").concat(_styleModule.default['_' + i], " "),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: " ".concat(_styleModule.default[sliderValue >= positiveBarsCount * 10 - 5 ? 'active' : ''])
          }, "po_".concat(i))
        }, "bar+".concat(i));
        positiveBarsCount++;
      }

      bars.push(bar);
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _styleModule.default.barsContainer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _styleModule.default.inner,
        children: bars
      })
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _styleModule.default.diagnosticSlider,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
      headline: t(config.translations.text),
      text: config.translations.hint ? t(config.translations.hint) : ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Bars, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      noBgColor: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
        container: true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          item: true,
          xs: 12,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSlider, {
            className: "".concat(_styleModule.default.styledSlider, " ").concat((0, _Onboarding.targetClassName)((_config$educationTool = config.educationTooltip) === null || _config$educationTool === void 0 ? void 0 : _config$educationTool.target)),
            onChangeCommitted: handleCommit,
            onChange: handleSlide,
            ThumbComponent: ThumbComponent,
            defaultValue: 0,
            max: config.maximumValue,
            min: config.minimumValue,
            initialValue: config.initialValue,
            value: sliderValue
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          item: true,
          xs: 6,
          className: _styleModule.default.sliderText,
          children: t(config.translations.minimumValueText)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          item: true,
          xs: 6,
          className: "".concat(_styleModule.default.sliderText, " ").concat(_styleModule.default.right),
          children: t(config.translations.maximumValueText)
        })]
      })
    })]
  });
};

var DiagnosticSliderWrapper = (0, _Optimizers.memoizeComponentByValue)(DiagnosticSliderComponent);

var DiagnosticSlider = function DiagnosticSlider(_ref2) {
  var config = _ref2.config;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DiagnosticSliderWrapper, {
    config: config,
    context: context
  });
};

exports.DiagnosticSlider = DiagnosticSlider;